import React from 'react';
import { Row, Col, FormGroup, Label, Input, Form, Button } from 'reactstrap';
import { getAccountDetails, editAccount, cancelEditAccount, updateAccount } from "../../../../../Redux/Actions/EndUser/AccountDetailsActions";
import { fetchStates } from "../../../../../Redux/Actions/CommonActions";
import { auth } from "../../../../../services";
import { connect } from 'react-redux';
import IsLoading from '../../../../Shared/Loading/IsLoading';
import SpanSpinner from '../../../../Shared/SpanSpinner/SpanSpinner';
import Modal from 'react-modal';
import { logout } from '../../../../../Redux/Actions/EndUser/AuthActions';
import axios from 'axios'
import { ROOT_API_URL } from '../../../../../api-config';
import _ from 'lodash';
import { Alert } from 'reactstrap';
import swal from 'sweetalert';
// import { getCounties } from '../../../../../Redux/Actions/Admin/ManageDistrictActions';

class AccountDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            details : {
                state : {
                    id: 0,
                    name: ''
                },
                countyObj:{
                    countyId:0,
                    countyName: ''
                },
				firstName: '',
				lastName: '',
				address1: '',
				address2: '',
				city: '',
				zip: '',
                phone: '',
                stateId: 0,
                userName: '',
                emailMessage: "",
            },
            isPopupVisible: false,
            pristine: {},
            alertVisible: false,
            alertColor: "danger",
            alertMessage: ""
        }
        this.delayedCallback = _.debounce(this.checkEmailCall, 500);
        this.onEmailChange = this.onEmailChange.bind(this);
    }
    checkEmailCall() {
        axios
            // .get(`${ROOT_API_URL}/ManageDistrict/CheckUserByEmail?email=${this.state.details.userName}`, { headers: auth.authHeader() })
            .post(`${ROOT_API_URL}/ManageDistrict/CheckUserByEmail`,
                {
                    email: this.state.details.userName
                },
                {
                    headers: auth.authHeader()
                }
            )
            .then((response) => {
                this.setState({
                    emailMessage: response.data.message ==="User does not exist. Please create the user."?"Email is available to use":response.data.message
                })
        })
        .catch((response) => {
            console.log(response);
        });
    }

    onEmailChange(event) {
        let target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.props ? target.props.name : target.name;

        const edited = this.state.details;
        edited[name] = value;
        edited.isActive = true;
        this.setState({
            details: edited,
            emailMessage: ""
        });

        if (name == 'userName' && !value) {

            this.setState({
                emailMessage: 'Email/Username is required.'
            });

        } else {

            this.delayedCallback();
        }
    }
    handleInputChange =(event) => {
        const target = event.target;
        this.setState({
            details: {
                ...this.state.details,
                [target.name]: target.value,
            },
        });
    }
    
    handleSelectChange = (event) => {
        const target = event.target;
        var obj = this.props.common.states.find(st => {  
            return (
                st.id === Number(target.value)
            );
        });
        this.setState({
            details: {
                ...this.state.details,
                [target.name]: obj,
            },
        });
    }
    
    // handleCountyChange = (event) => {
    //     console.log(event);
    //     const target = event.target;
    //     var obj = this.props.district.counties.find(st => {  
    //         return (
    //             st.countyId === Number(target.value)
    //         );
    //     });
    //     this.setState({
    //         details: {
    //             ...this.state.details,
    //             [target.name]: obj,
    //         },
    //     });
    // }

    componentDidMount() {
        this.props.getAccountDetails(auth.getAuthUserEmail());
        this.props.fetchStates();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.details !== this.props.details) {
            var obj = Object.assign({}, this.props.details);
            obj.state = {
                // id: this.props.details.state.stateId,
                // name: this.props.details.state.description
                id: this.props.details.state ? this.props.details.state.stateId : 0,
                name: this.props.details.state ? this.props.details.state.description : ''
            }
            this.setState({
                details: obj
            });
        }

        if ((prevProps.error != this.props.error) && this.props.error) {
            this.setState({
                alertVisible: true,
                alertColor: "danger",
                alertMessage: this.props.error
            });
            setTimeout(() => {
                this.setState({
                    alertVisible: false,
                    alertMessage: ''
                });
            }, 5000);
        }
    }

    edit =() => {
        var obj = JSON.parse(JSON.stringify(this.state.details));        
        // this.props.getCounties(obj.state.id);
        this.setState({pristine: obj});
        this.props.editAccount(null);
    }

    cancel = () => {
        this.setState({ details: this.state.pristine });
        this.setState({
            emailMessage: ""
        });
        this.props.cancelEditAccount(null);
    }

    update = (event) => {

        if (auth.isAuthenticated()) {

            this.props.updateAccount({
                ...this.state.details,
                state: {
                    stateId: this.state.details.state ? this.state.details.state.id : 0,
                    description: this.state.details.state ? this.state.details.state.name : '',
                    emailMessage: ""
                }
            });
                

        }
        event.preventDefault();

        if (this.state.pristine.userName !== this.state.details.userName) {
            this.setState({ isPopupVisible: false })
            logout();
        }


    }

    popUp = (event) => {

        if (!this.state.details.userName) {
            this.setState({
                emailMessage: 'Email/Username is required.'
            });
            return;
        }

        if (this.state.pristine.userName !== this.state.details.userName) {
            //this.setState({ isPopupVisible: true });
            swal({
                title: `Are you sure?`,
                text: `You want to change your email from: ${this.state.pristine.userName} to: ${this.state.details.userName}?\nBy clicking yes you will be logged out and need to confirm your new email: ${this.state.details.userName}`,
                icon: 'warning',
                buttons: {
                    cancel: 'CANCEL',
                    confirm: 'YES'
                },
                dangerMode: true
            }).then((confirmed) => {
                if (confirmed) {
                    this.update(event);
                } 
            });
            
        } else {
            this.update(event);
        }
    }

    cancelPopUp = () => {
        this.setState({ isPopupVisible: false })
    };


    getUpdateButtons(){
        if (this.props.editting)
        return (
            <div className="btn-container">
                <div  className="cols">
                    <div className="col-left">
                        <Button block 
                            color="secondary"
                            className="btnSecondary" 
                             onClick={this.cancel}>
                         CANCEL</Button>
                    </div>                    
                    <div className="col-right">
                        <Button block 
                            color="primary"
                            className="btnPrimary" 
                            onClick={this.popUp}>
                                {
                                    this.props.updating
                                    ? <SpanSpinner message="Updating ..." />
                                    : <span>UPDATE</span>
                                }
                         </Button>
                    </div>
                </div>
            </div>
        )
        return null;
    }

    render() {
        if (this.props.getting)
        return (
            <div>
                <IsLoading />
            </div>
        )
        return (
            <div className="account-tab-content authorized-members">
                
                <div>
                    <Alert
                        color={this.state.alertColor}
                        isOpen={this.state.alertVisible}
                        toggle={() => {
                            this.setState({ alertVisible: false, alertMessage: "" })
                        }}
                    >
                        {this.state.alertMessage}
                    </Alert>
                    <div>
                        <div>
                            <h1 className="pt-3 pb-3 header-long">Account Details</h1>
                            <div className="account-tab-content-right">
                                <Button 
                                    color="primary" 
                                    size="sm" 
                                    disabled = {this.props.editting}
                                    className="btnPrimary btnEdit" 
                                    onClick={this.edit}>
                                    EDIT INFO BELOW
                                </Button>
                            </div>
                        </div>
                        <Form className="edit-account-form card">
                            <div className="list-group list-group-flush dashboard-info-list">
                                <FormGroup className="list-group-item">
                                    <Label htmlFor="firstName">First Name:</Label>
                                    <Input type="text" 
                                        name="firstName" 
                                        id="firstName" 
                                        disabled = {!this.props.editting}
                                        value={this.state.details.firstName} 
                                        placeholder="Enter First Name" 
                                        onChange={this.handleInputChange}/>
                                </FormGroup>
                                <FormGroup className="list-group-item">
                                    <Label htmlFor="lastName">Last Name:</Label>
                                    <Input type="text" 
                                        name="lastName" 
                                        disabled = {!this.props.editting}
                                        id="lastName" 
                                        value={this.state.details.lastName} 
                                        placeholder="Enter Last Name" 
                                        onChange={this.handleInputChange}/>
                                </FormGroup>
                            </div>
                            <div className="list-group list-group-flush dashboard-info-list">
                                <FormGroup className="list-group-item">
                                    <Label htmlFor="userName">Email:</Label>
                                    <Input type="text"
                                        name="userName"
                                        id="userName"
                                        disabled={!this.props.editting}
                                        value={this.state.details.userName}
                                        placeholder="Enter Email / UserName"
                                        //onChange={this.handleInputChange} />
                                        onChange={this.onEmailChange}/>
                                        <p className="error-message">{this.state.emailMessage}</p>
                                </FormGroup>
                               
                            </div>
                            <div className="list-group list-group-flush dashboard-info-list">
                                <FormGroup className="list-group-item">
                                    <Label htmlFor="address1">Address 1:</Label>
                                    <Input type="text" 
                                        name="address1" 
                                        disabled = {!this.props.editting}
                                        id="address1" 
                                        value={this.state.details.address1} 
                                        placeholder="Enter Address 1" 
                                        onChange={this.handleInputChange}/>
                                </FormGroup>
                                <FormGroup className="list-group-item">
                                    <Label htmlFor="address2">Address 2:</Label>
                                    <Input type="text"
                                        name="address2"
                                        disabled={!this.props.editting}
                                        id="address2"
                                        value={this.state.details.address2}
                                        placeholder="Enter Address 2"
                                        onChange={this.handleInputChange} />
                                </FormGroup>
                            </div>

                            <div className="list-group list-group-flush dashboard-info-list">
                                <FormGroup className="list-group-item">
                                    <Label htmlFor="city">City:</Label>
                                    <Input type="text" 
                                        name="city" 
                                        disabled = {!this.props.editting}
                                        id="city" 
                                        value={this.state.details.city} 
                                        placeholder="City" 
                                        onChange={this.handleInputChange}/>
                                </FormGroup>
                                {/* <FormGroup  className="list-group-item">
                                    <Label htmlFor="countyObj">County:</Label>
                                    {
                                        this.props.editting ?
                                            <Input type="select"
                                                name="countyObj"
                                                disabled={!this.props.editting}
                                                id="countyObj"
                                                onChange={this.handleCountyChange}
                                                value={this.state.details.countyObj.countyId}>
                                                {
                                                    this.props.district.counties.map((option, index) =>
                                                        <option key={index} value={option.countyId}>
                                                            {option.countyName}
                                                        </option>
                                                    )}
                                            </Input> :
                                            <Input
                                                type="text" 
                                                name="countyObj" 
                                                disabled = {!this.props.editting}
                                                id="countyObj" 
                                                value={this.state.details.countyObj.countyName}
                                                placeholder="County" 
                                                onChange={this.handleInputChange}
                                        />
                                    }
                                    
                                </FormGroup> */}
                            </div>

                            <div className="list-group list-group-flush dashboard-info-list">
                                <FormGroup className="list-group-item">
                                    <Label htmlFor="state">State:</Label>
                                    
                                    {this.props.editting ?
                                        <Input type="select"
                                            name="state"
                                            disabled={!this.props.editting}
                                            id="state"
                                            onChange={this.handleSelectChange}
                                            value={this.state.details.state ? this.state.details.state.id : 0}>
                                                <option value='0'></option>
                                            {
                                                this.props.common.states.map((option, index) =>
                                                    <option key={index} value={option.id}>
                                                        {option.name}
                                                    </option>
                                                )}
                                        </Input> :
                                        <Input type="text"
                                            name="state"
                                            disabled={!this.props.editting}
                                            id="state"
                                            value={this.state.details.state ? this.state.details.state.name : ''}
                                            placeholder="state"
                                            onChange={this.handleInputChange} />
                                    }
                                </FormGroup>
                                <FormGroup className="list-group-item">
                                    <Label htmlFor="zip">Zip Code:</Label>
                                    <Input type="text" 
                                        name="zip" 
                                        disabled = {!this.props.editting}
                                        id="zip" 
                                        value={this.state.details.zip} 
                                        placeholder="Zip Code" 
                                        onChange={this.handleInputChange}/>
                                </FormGroup>
                            </div>
                            <div className="list-group list-group-flush dashboard-info-list">
                                <FormGroup className="list-group-item">
                                    <Label htmlFor="phone">Phone:</Label>
                                    <Input type="text" 
                                        name="phone" 
                                        id="phone" 
                                        disabled = {!this.props.editting}
                                        value={this.state.details.phone} 
                                        placeholder="Phone Number" 
                                        onChange={this.handleInputChange}/>
                                </FormGroup>
                                <div className="list-group-item">
                                    <p>
                                        <span className="list-group-header">Member Since:</span>
                                        <strong className="list-group-text">{this.props.details.membershipDate}</strong>
                                    </p>
                                </div>
                            </div>
                             {this.getUpdateButtons()}
                    </Form>
                </div>
                    <Col sm="12" md="6">
                    </Col>
                </div>
                {/*<Modal
                    isOpen={this.state.isPopupVisible}
                    onRequestClose={this.cancelPopUp}
                    contentLabel="Example Modal"
                    ariaHideApp={false}
                    style={{
                        content: {
                            top: '50%',
                            left: '50%',
                            right: 'auto',
                            bottom: 'auto',
                            marginRight: '-50%',
                            minWidth: '50vw',
                            maxWidth: '50vw',
                            minHeight: '20vh',
                            maxHeight: '20vh',
                            overflow: 'auto',
                            transform: 'translate(-50%, -50%)',
                            borderRadius: '5px'
                        }
                    }}
                >
                    <div>
                        <p>Are you sure you want to change your email to: {this.state.details.userName} from: {this.state.pristine.userName}?</p>
                        <p>By clicking yes you will be logged out and need to confirm your new email-{this.state.details.userName} </p>
                        <button onClick={this.update}>Yes</button>
                        <button onClick={this.cancelPopUp}>No</button>
                    </div>
                </Modal>*/}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        common: state.common,
        details: state.accountDetails.details,
        error: state.accountDetails.error,
        updating: state.accountDetails.updating,
        getting: state.accountDetails.getting,
        pristine: state.accountDetails.pristine,
        email: state.accountDetails.email,
        editting: state.accountDetails.editting,
        //district: state.district,
    };
}

export default connect(mapStateToProps, {
    getAccountDetails,
    fetchStates,
    editAccount,
    cancelEditAccount,
    updateAccount,
    //getCounties
})(AccountDetails);